import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PndApi from '../../../../utils/pnd/PndRestApi';
import LinearProgress from '@mui/material/LinearProgress';
import { Field, reduxForm } from 'redux-form';
import renderSelectField from 'src/shared/components/form/Select';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { connect } from 'react-redux';
import { IconButton, CircularProgress, Tooltip } from '@mui/material';
import RiderLocationMapModal from './components/RiderLocationMapModal';
import { formatDate } from 'src/utils/DateUtils';
import { showNotification } from 'src/shared/components/Notification';
import SearchIcon from '@mui/icons-material/Search';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import renderMuiDateTimePickerField from 'src/shared/components/form/MuiDatePicker';
import PndRestApi from '../../../../utils/pnd/PndRestApi';
import RiderLocationHistoryDetails from './components/RiderLocationHistoryDetails';

const LocationHistory = ({ reset, formValues }) => {
  useEffect(() => {
    getAllRidersDetails();

  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [riderIds, setRiderIds] = useState([]);
  const [isGoogleMapView, setGoogleMapView] = useState(null);
  const [data, setData] = useState(null);
  const getAllRidersDetails = async () => {
    let riderId = [];
    try {
      setLoading(true);
      const response = await PndApi.GetAllRidersDetails();
      if (response.status === 200 && response.data.status === 200) {
        response.data.data.map(item => {
          riderId.push({ "label": item.riderName, "value": item.driverId, "riderId": item.riderId });
        })
        setRiderIds(riderId);
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
        return;
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Rider Name',
        accessor: 'driverName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Date Time',
        accessor: 'dateTime',
        Cell: ({ value }) => formatDate(value),
        disableGlobalFilter: true,
      },
      {
        Header: 'Plate Number',
        accessor: 'plateNo',
        disableGlobalFilter: false,
      },


      {
        Header: 'Vehicle Status',
        accessor: 'vehicleMode',
        disableGlobalFilter: false,
      },
      {
        Header: 'Speed',
        accessor: 'speed',
        disableGlobalFilter: true,
      },

      {
        Header: 'Emirate',
        accessor: 'emirate',
        disableGlobalFilter: false,
      },
      {
        Header: 'City',
        accessor: 'city',
        disableGlobalFilter: false,
      },
      {
        Header: 'Location',
        accessor: 'location',
        disableGlobalFilter: false,
      },

      {
        Header: "Map View",
        accessor: "mapView",
        disableSortBy: true,

        Cell: row => (

          <Tooltip title="Click here to open the location in Google Map">
            <AddLocationAltIcon style={{ cursor: "pointer", color: 'green' }} onClick={() => openMap(row.row.original)} />
          </Tooltip>
        )

      },
    ],
    [],
  );
  const openMap = async (event) => {
    if (event) {
      setData(event);
      setGoogleMapView(true);

    }
  }
   const searchBasedOnFilters = async () => {
    try {
      setLoading(true);
      setNoRecordFound(false);
      setReactTableData([]);
      if (formValues?.riderId?.value === undefined) {
        showNotification(
          "theme-light",
          "ltr",
          `Warning`,
          `Please select the required fields to search.`,
        );
      } else {
        let Obj = {
          riderId: formValues?.riderId?.value,
          fromDate: formValues?.fromDate ? formatDateForBackend(new Date(formValues.fromDate)) : null,
          toDate: formValues?.toDate ? formatEndDate(new Date(formValues.toDate)) : null,
          page: 0,
          size: 1000,
        }

        if (Obj?.fromDate && Obj?.toDate && Obj?.riderId) {
          const response = await PndRestApi.GetRidersLocationHistory(Obj);
          if (response.status === 200 && response.data.status === 200) {
            const rowsData = response.data.data && Array.isArray(response.data.data) ? response.data.data : (response.data.data?.content || []);
            if (rowsData.length > 0) {
              setReactTableData({ tableHeaderData: columns, tableRowsData: rowsData });
              setNoRecordFound(false);
            } else {
              setNoRecordFound(true);
              setReactTableData({ tableHeaderData: columns, tableRowsData: null });
            }
          } else if (response.status && response?.data?.status === 204) { //No Record Found
            setNoRecordFound(true);
            setReactTableData({ tableHeaderData: columns, tableRowsData: null });
          } else {
            showNotification(
              "theme-light",
              "ltr",
              `ErrorCode: 500`,
              ERROR_MESSAGES.tryCatchError,
            );
          }
        }
      }
    } catch (error) {
      console.log("error", error);
      showNotification(
        "theme-light",
        "ltr",
        `ErrorCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };
  const formatDateForBackend = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00.000Z`; // Set time to midnight UTC
  };

  const formatEndDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    // Set to 23:59:59 UTC
    return `${year}-${month}-${day}T23:59:59.000Z`;
  };

  const clearFilters = () => {
    reset();
  };

  return (
    <Container fluid className="px-2 py-2">
      <Card className="border-0 shadow-sm mb-3">
        <CardHeader className="bg-white py-2 border-bottom-0">
          <h6 className="mb-0 fw-bold text-primary">Rider Location History</h6>
        </CardHeader>
        <CardBody className="p-3">
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <div className="d-flex align-items-end flex-wrap gap-3">
              <div style={{ width: '220px' }}>
                <label className="form-label fw-bold text-secondary mb-1" style={{ fontSize: '0.92rem' }}>From Date</label>
                <Field
                  name="fromDate"
                  component={renderMuiDateTimePickerField}
                  fullWidth
                  size="small"
                  margin="none"
                />
              </div>
              <div style={{ width: '220px' }}>
                <label className="form-label fw-bold text-secondary mb-1" style={{ fontSize: '0.92rem' }}>To Date</label>
                <Field
                  name="toDate"
                  component={renderMuiDateTimePickerField}
                  fullWidth
                  size="small"
                  margin="none"
                />
              </div>
              <div style={{ width: '280px' }}>
                <label className="form-label fw-bold text-secondary mb-1" style={{ fontSize: '0.92rem' }}>Driver Name</label>
                <Field
                  name="riderId"
                  component={renderSelectField}
                  type="text"
                  options={riderIds}
                  placeholder="Select Driver Name"
                  menuPortalTarget={document.body}
                />
              </div>
              <div className="d-flex gap-2 mb-1">
                <Tooltip title="Clear Filters" arrow>
                  <IconButton
                    onClick={clearFilters}
                    size="small"
                    sx={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      '&:hover': { backgroundColor: '#e2e6ea' }
                    }}
                  >
                    <RestartAltIcon fontSize="small" color="action" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Search Location History" arrow>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={searchBasedOnFilters}
                    disabled={loading}
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      '&:hover': { backgroundColor: 'primary.dark' },
                      '&.Mui-disabled': { backgroundColor: '#ccc' }
                    }}
                  >
                    {loading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon fontSize="small" />}
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </form>
        </CardBody>
      </Card>

      <Card className="border-0 shadow-sm">
        <CardBody className="p-2">
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
            <RiderLocationHistoryDetails reactTableData={reactTableData} />}
          {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
          {isNoRecordFound && <RiderLocationHistoryDetails reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />}

          {isGoogleMapView &&
            <RiderLocationMapModal
              modalShow={isGoogleMapView}
              setModalShow={setGoogleMapView}
              data={data}

            />}
        </CardBody>
      </Card>
    </Container>
  );
};


const mapStateToProps = (state) => ({
  formValues: state.form.RiderLocationHistoryForm ? state.form.RiderLocationHistoryForm.values : {},
});
export default connect(mapStateToProps)(reduxForm({ form: 'RiderLocationHistoryForm', enableReinitialize: true })(LocationHistory))